<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="entradas"
            hide-filters
            ref="Table"
        >
            <template v-slot:cell(material)="{ item }">
                <template v-if="item.material.codigoMaterial">{{ item.material.codigoMaterial }} - </template>
                {{ item.material.descricao }} - {{ item.material.unidadeMedidaSigla }}
            </template>

            <template v-slot:cell(actions)="{ index, item }">
                <rkm-button
                    @click.stop="$refs.ModalDetalhes.open(item)"
                    color="outline-primary"
                    small
                    title="Exibir detalhes"
                >
                    <rkm-icon icon="align-justify" />
                </rkm-button>

                <rkm-button
                    @click.stop="remove(index)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>

            <template #afterTable>
                <div class="my-2">
                    <rkm-row>
                        <rkm-col class="text-right">
                            <h6 class="font-weight-bold">Quantidade de materiais inclusa: {{ entradas.length }}</h6>
                        </rkm-col>

                        <rkm-col cols="auto">
                            <h6 class="font-weight-bold">Valor total: R$ {{ valorTotal }}</h6>
                        </rkm-col>
                    </rkm-row>
                </div>
            </template>
        </rkm-table>

        <ModalDetalhes ref="ModalDetalhes" />
    </div>
</template>

<script>
// Components.
import ModalDetalhes from './components/detalhe/Modal'

// Mixins.
import { formats } from '@/mixins'

export default {
    components: { ModalDetalhes },
    computed: {
        fields() {

            return [
                {
                    key: 'quantidade',
                    label: 'Quantidade',
                    sortable: true,
                    class: 'col-min'
                },
                {
                    key: 'lote',
                    label: 'Lote',
                    sortable: true,
                    class: 'col-min'
                },
                {
                    key: 'validadeLote',
                    label: 'Validade do lote',
                    sortable: true,
                    class: 'col-min'
                },
                {
                    key: 'valorUnitario',
                    label: 'Valor unitário',
                    sortable: true,
                    class: 'col-min'
                },
                {
                    key: 'valorTotal',
                    label: 'Valor total',
                    sortable: true,
                    class: 'col-min'
                },
                {
                    key: 'codigoBarras',
                    label: 'Código de barras',
                    sortable: true,
                    class: 'col-min'
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        },
        valorTotal() {

            let valorTotal = 0.0

            this.entradas.map(i => valorTotal += this.formatSumMoney(i.valorTotal))

            return this.formatMoney(valorTotal, 6)
        }
    },
    methods: {
        remove(index) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir a entrada?',
                async () => this.entradas.splice(index, 1)
            )
        },
    },
    mixins: [ formats ],
    props: {
        entradas: { type: Array, required: true }
    }
}
</script>